export default __webpack_public_path__ + "static/media/id.d86b0a3e.svg";